/*
 * @Auther: 罗耀祖
 * @Date: 2022-04-24 13:57:29
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-30 10:11:55
 * @name: 工作流模块控制器
 * @Description: 工作流模块控制器
 * @FilePath: \project\src\module\workflow\workflow.controller.js
 * @Author: desktop
 */
import { Controller, Get, Post, Validator } from "@/nestVue/common";
@Controller('workflow')
class workflowController {
  constructor() {

  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 待打回的步骤列表
   * @param {Object} ctx 请求上下文
   */
  @Get('getSaleSercviceFlowProcessList.html')
  getSaleSercviceFlowProcessList(ctx) { }
}
export default workflowController;